import { normalizeRegionName } from '../../../../../helpers/addressParser'
import { SelectOptionInstruction } from '../SelectOptionInstruction'

export class RegionInstruction extends SelectOptionInstruction {
  constructor ({ option, waitForNoLoaders, label }) {
    super({
      name: 'Region',
      option,
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      label
    })
  }

  setDefaultValue (params) {
    this.option = normalizeRegionName(params.addressInformation.region)
  }
}
